export default __webpack_public_path__ + "static/media/no-data-icon.c469fae2.svg";